import { Component, OnInit, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from "../../../base/base-component.component";
import { AppConfigProvider } from "../../../app-config.provider";
import { PersistenceStorageService } from "../../../services";
import { AppToken } from "../../../models/app-token";
import { PageTitleService } from "../../../services/general/page-title.service";
import { AuthenticationService } from "../../../services/general/index";

@Component({
  selector: 'top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.css']
})
export class TopMenuComponent extends BaseComponent implements OnInit, AfterViewInit {

  @Output()
  whenLanguageChange = new EventEmitter();

  availableLanguages: string[];
  availableLanguagesNames: {};
  username: string;

  userIsOwner: boolean;
  userIsDev: boolean;
  userIsEditor: boolean;

  previewUrl: string = '';
  previewPage: string = ''; // Not used


  constructor(
    private readonly persistenceStorageService: PersistenceStorageService,
    protected readonly translateService: TranslateService,
    private readonly pageTitleService: PageTitleService,
    private readonly authenticationService: AuthenticationService,
    appConfigProvider: AppConfigProvider) {
    super(translateService);
    this.setTranslateContext('TopMenuComponent');
    this.availableLanguages = appConfigProvider.getAvailableLanguages();
    this.availableLanguagesNames = appConfigProvider.getAvailableLanguagesNames();
  }

  ngOnInit() {
    const subscribe = this.pageTitleService.getTitle().subscribe(v => {
      this.pageTitle = v;
    });
    this.subscriptions.push(subscribe);
    this.setUserInfos();
    this.userIsOwner = this.authenticationService.userHasRole("Owner");
    this.userIsDev = this.authenticationService.userHasRole("Developer");
    this.userIsEditor = this.authenticationService.userHasRole("Editor");
    this.previewUrl = window.location.origin;

  }


  ngAfterViewInit() {
  //  if (this.document) {
  //    const url = `${this.document.location.origin}/`;
  //    this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  //  }
  }


  useLanguage(language: string) {
    this.persistenceStorageService.set(AppToken.USER_SAVE_CULTURE_CODE, language);
    this.translateService.use(language).toPromise().then(lang => {
      if (this.pageTitleService.key) {
        this.ts(this.pageTitleService.key).subscribe(t => {
          this.pageTitle = t.toString();
        });
      }
    });
    this.whenLanguageChange.emit(language);
  }

  toggleIt() {
    const element: HTMLCollection = document.getElementsByTagName('body');
    if (element[0].classList.contains('open_menu')) {
      element[0].classList.remove('open_menu');
    } else {
      element[0].classList.add('open_menu');
    }
  }

  setUserInfos(): void {
    const sub = this.authenticationService
      .getCurrentUser()
      .subscribe(v => {
        if (!v) return;
        if (typeof v.data.fullname != "undefined" && v.data.fullname.iv.trim()) {
          this.username = v.data.fullname.iv;
        } else {
          this.username = v.data.email.iv;
        }
      });
    this.subscriptions.push(sub);
  }
}
